export default __webpack_public_path__ + "static/media/image1.0eb34e05.avif";